declare namespace $ {

	type $mol_view__sub_bog_max_nav_item_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_max_nav_item extends $mol_link {
		Label( ): $mol_view
		label( ): string
		active( ): string
		Icon( ): $mol_view
		attr( ): ({ 
			'bog_max_nav_active': ReturnType< $bog_max_nav_item['active'] >,
		})  & ReturnType< $mol_link['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map